// extracted by mini-css-extract-plugin
export default {"container":"settings_container__mJEc4","deviewText":"settings_deviewText__OwZ3C","link":"settings_link__4EdnY","fullWidth":"settings_fullWidth__FP5wZ"};